import { render, staticRenderFns } from "./CopyShopData.vue?vue&type=template&id=10ab483a&"
import script from "./CopyShopData.vue?vue&type=script&lang=js&"
export * from "./CopyShopData.vue?vue&type=script&lang=js&"
import style0 from "./CopyShopData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports